<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="编辑新闻" />
		<NewForm :newsForm="form" @eventForm="handleGetForm" />
	</div>
</template>

<script>
	import NewForm from '@/components/News/Form'
	export default {
		data() {
			return {
				form: {}
			}
		},
		created() {
			this.$axios.post('Myseller-setting-getnews', {
				id: this.$route.query.id
			}).then(data => {
				this.form = data
			})
		},
		methods: {
			handleGetForm(form) {
				this.$axios.post('Myseller-setting-addnews', form).then(data => {
					this.$message.success('修改成功')
					this.$router.push('/news')
				})
			}
		},
		components: {
			NewForm
		}
	}
</script>

<style>
</style>
